import { render, staticRenderFns } from "./LoginLogsPage.vue?vue&type=template&id=3ca82114&scoped=true"
import script from "./LoginLogsPage.vue?vue&type=script&lang=ts"
export * from "./LoginLogsPage.vue?vue&type=script&lang=ts"
import style0 from "./LoginLogsPage.vue?vue&type=style&index=0&id=3ca82114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca82114",
  null
  
)

export default component.exports